import { WorkspaceToNhsOrganisationMappingRequest } from "@accurx/api/account";
import { httpClient2 } from "@accurx/shared";
import { useMutation } from "@tanstack/react-query";

const ORGANISATION_QUERY_KEY = "MapWorkspaceToNhsOrganisation";

export const useMapToNhsOrganisationMutation = (workspaceId: number) => {
    return useMutation({
        mutationKey: [ORGANISATION_QUERY_KEY, { workspaceId }],
        mutationFn: async ({
            organisationId,
            nhsOrganisationId,
        }: WorkspaceToNhsOrganisationMappingRequest): Promise<unknown> => {
            return await httpClient2.post({
                path: "/api/account/WorkspaceMapping/mapToNhsOrganisation",
                json: {
                    organisationId,
                    nhsOrganisationId,
                },
            });
        },
    });
};
